/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import swal from "sweetalert";
import { appConstants } from "utils/appConstants";
import LoadingModal from "../../../components/LoadingModel/loadingModal";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let id = undefined;

function AddNewChecklist() {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [screenName, setScreenName] = useState("Add Driver Checklist");
  // const [mandateFlag, setMandateFlag] = useState();
  const [checklistNameErr, setchecklistNameErr] = useState();
  const [checklistSequenceErr, setchecklistSequenceErr] = useState();
  const [checkListStatuseErr, setcheckListStatuseErr] = useState();

  const [checklistTypeErr, setchecklistTypeErr] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;

  const [values, setValues] = React.useState({
    searchParameter: "",
    searchParameterList: ["checkListName", "checkListSequence"],
    checkListName: "",
    checkListSequence: "",
    checkListType: "",
    checkListStatus: "Active",
  });

  // LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  // values.businessUserID = LOGIN_DETAILS.businessUserID;

  const handleChange = (name) => (event) => {
    let { value } = event.target;

    if (name === "checkListSequence") {
      value = value.replace(/\D/g, ""); // Remove non-numeric characters
    }

    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    if (id !== undefined) {
      setScreenName("Edit Driver Checklist");
      values._id = id;
      setLoading(true);
      axios
        .post(appConstants.baseURL + "checklist/fetchChecklistByID", values)
        .then((res) => {
          setLoading(false);
          let response = res.data;
          if (response.Result_Output.length > 0) {
            setValues(response.Result_Output[0]);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in fetchChecklistByID=", error);
        });
    }
  }, []);

  let mandateFlag;

  const addChecklist = () => {
    setchecklistNameErr(false);
    setchecklistSequenceErr(false);
    setchecklistTypeErr(false);
    setcheckListStatuseErr(false);
    mandateFlag = false;
    setLoading(false);

    if (values.checkListName.trim() === "") {
      setchecklistNameErr(true);
      mandateFlag = true;
    }

    if (values.checkListSequence.trim() === "") {
      setchecklistSequenceErr(true);
      mandateFlag = true;
    }

    if (values.checkListType === "") {
      setchecklistTypeErr(true);
      mandateFlag = true;
    }

    if (values.checkListStatus === "") {
      setcheckListStatuseErr(true);
      mandateFlag = true;
    }

    if (mandateFlag) {
      return;
    }

    if (id === undefined) {
      setLoading(true);
      console.log("values", values);

      axios
        .post(appConstants.baseURL + "checklist/addChecklist", values)
        .then((res) => {
          setLoading(false);
          let response = res.data;
          if (response.Result_Status) {
            swal({
              title: "Added successfully!",
              text: "",
              icon: "success",
              color: "red",
              button: false,
              timer: 2000,
            });
            setTimeout(() => {
              window.location.href = "/newChecklist";
            }, 2000);
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in Add New Checklist" + JSON.stringify(error));
        });
    } else {
      setLoading(true);
      axios
        .post(appConstants.baseURL + "checklist/ChecklistUpdate", values)
        .then((res) => {
          setLoading(false);
          let response = res.data;
          if (response.Result_Status) {
            swal({
              title: "Updated successfully!",
              text: "",
              icon: "success",
              color: "green",
              button: false,
              timer: 2000,
            });
            setTimeout(() => {
              window.location.href = "/newChecklist";
            }, 1000);
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in  updateChecklist =" + JSON.stringify(error));
        });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={6} spacing={6}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>

              <MDBox pt={4} pb={3} px={3}>
                <Grid container rowGap={3}>
                  <Grid item xs={12} lg={12}>
                    <MDBox component="form" role="form">
                      <TextField
                        type="text"
                        label="Checklist Name"
                        variant="outlined"
                        fullWidth
                        value={values.checkListName}
                        inputProps={{
                          pattern: "^[a-zA-Z0-9 ]+$",
                          maxLength: 30,
                        }}
                        onChange={handleChange("checkListName")}
                      />
                      {checklistNameErr ? (
                        <span style={errMsg}>
                          Checklist Name can't be blank
                        </span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <MDBox component="form" role="form">
                      <TextField
                        type="text"
                        label="Checklist Sequence"
                        maxLength="20"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          pattern: "[0-9]*",
                          maxLength: 2,
                        }}
                        value={values.checkListSequence}
                        onChange={handleChange("checkListSequence")}
                      />
                      {checklistSequenceErr ? (
                        <span style={errMsg}>
                          Checklist Sequence can't be blank
                        </span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Checklist Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ minHeight: "3em" }}
                        label="Checklist Type"
                        value={values.checkListType}
                        onChange={handleChange("checkListType")}
                      >
                        <MenuItem value="Optional">Optional</MenuItem>
                        <MenuItem value="Mandatory">Mandatory</MenuItem>
                      </Select>
                    </FormControl>
                    {checklistTypeErr ? (
                      <span style={errMsg}>Checklist Type can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Checklist Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        name="userType"
                        id="demo-simple-select"
                        style={{ minHeight: "3em" }}
                        label=" Checklist Status"
                        onChange={handleChange("checkListStatus")}
                        value={values.checkListStatus}
                      >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                    {checkListStatuseErr ? (
                      <span style={errMsg}>
                        Driver CheckList Status can't be blank
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Grid
        container
        mt={2}
        columnSpacing={4}
        alignItems="center"
        display="flex"
        justifyContent="center"
      >
        <Grid item xs={12} md={4} spacing={2} lg={1.2}>
          <Link to={"/newChecklist"}>
            <MDButton
              className="btn-block center-container-btn btn-warning btn-back rightSpace"
              color="warning"
              fullWidth
              onClick={() => {
                sessionStorage.setItem("PARA_TABLE", "BusinessUserChecklist");
              }}
            >
              Cancel
            </MDButton>
          </Link>
        </Grid>
        <Grid item xs={12} md={4} spacing={2} lg={1.2}>
          <MDButton
            rel="noreferrer"
            variant="gradient"
            color="success"
            fullWidth
            onClick={addChecklist}
          >
            {id === undefined ? "Save" : "Update"}
          </MDButton>
        </Grid>
      </Grid>

      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}
export default AddNewChecklist;
